export enum Keys {
    A = 65,    B = 66,    C = 67,    D = 68,    E = 69,
    F = 70,    G = 71,    H = 72,    I = 73,    J = 74,
    K = 75,    L = 76,    M = 77,    N = 78,    O = 79,
    P = 80,    Q = 81,    R = 82,    S = 83,    T = 84,
    U = 85,    V = 86,    W = 87,    X = 88,    Y = 89,
    Z = 90,
    Num0 = 48,    Num1 = 49,    Num2 = 50,    Num3 = 51,
    Num4 = 52,    Num5 = 53,    Num6 = 54,    Num7 = 55,
    Num8 = 56,    Num9 = 57,
    NumPad0 = 96,    NumPad1 = 97,    NumPad2 = 98,
    NumPad3 = 99,    NumPad4 = 100,    NumPad5 = 101,
    NumPad6 = 102,    NumPad7 = 103,    NumPad8 = 104,
    NumPad9 = 105,
    Esc = 27,    Tab = 9,    Space = 32,    Enter = 13,
    Shift = 16,    Ctrl = 17,    Alt = 18,
    Left = 37,    Up = 38,    Right = 39,    Down = 40,
    Plus = 187,    Minus = 189,    Comma = 188,
    Period = 190,    Slash = 191,    Backslash = 220,
    Apostrophe = 222,    Semicolon = 186,    BackSpace = 8,
    Delete = 46,    Home = 36,    End = 35,
    PageUp = 33,    PageDown = 34,
    PrintScreen = 44,
    F1 = 112,    F2 = 113,    F3 = 114,    F4 = 115,
    F5 = 116,    F6 = 117,    F7 = 118,    F8 = 119,
    F9 = 120,    F10 = 121,    F11 = 122,    F12 = 123,
    CapsLock = 20,
};



// WEBPACK FOOTER //
// ./src/app/shared/etc/keys.ts